export default __webpack_public_path__ + "static/media/back-button.3cbd15e5.svg";